import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { IMAGE_CONFIG } from '@angular/common';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { ChevronRight, LogIn, LucideAngularModule, Mail, Pencil, Phone } from 'lucide-angular';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { environment } from 'src/environments/environment';
import { initializeApp } from './app-init.service';
import { routes } from './app.routes';
import { ApiModule, Configuration } from './client';
import { AppConfigModule } from './core/components/app-config';
import { SpinnerInterceptor } from './core/components/spinner/spinner.interceptor';
import { SpinnerService } from './core/components/spinner/spinner.service';
import { AuthGuard } from './core/guards/auth.guard';
import { HttpRequestInterceptor } from './core/interceptors/http-request.interceptor';
import { AuthServices } from './core/services/auth.services';
import { AppSettingsService } from './core/services/app-settings.service';
import { ChunkDownloadService } from './core/services/chunk-download.service';
import { CsvUtilsService } from './core/services/csv-utils.service';
import { DomainValuesSharedService } from './core/services/domain-values.shared.service';
import { RolesSharedService } from './core/services/roles-shared.service';
import { SitesSharedService } from './core/services/sites-shared.service';
import { SourcesSharedService } from './core/services/sources-shared.service';
import { UserSharedService } from './core/services/user-shared.service';
import localeIt from '@angular/common/locales/it';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localeIt);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      LucideAngularModule.pick({ Pencil, LogIn,ChevronRight, Phone, Mail }),
      AppConfigModule.forRoot({
        applicationId: environment.applicationId,
        redirectUrl: environment.redirectUrl,
      }),
      ApiModule.forRoot(
        () =>
          new Configuration({
            basePath: environment.apiUrl,
            withCredentials: true,
          }),
      ),
    ),
    DialogService,
    ConfirmationService,
    DomainValuesSharedService,
    RolesSharedService,
    UserSharedService,
    SourcesSharedService,
    SitesSharedService,
    CsvUtilsService,
    ChunkDownloadService,
    MessageService,
    SpinnerService,
    AuthGuard,
    AuthServices,
    AppSettingsService,
    { provide: LOCALE_ID, useValue: 'it-IT' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [],
      multi: true,
    },
    {
      provide: IMAGE_CONFIG,
      useValue: {
        disableImageSizeWarning: true,
      },
    },
  ],
};
